import { Listeners } from "./types";
import {
  socketMessageKinds,
  validateApplicationVersionMessageData,
  validateCampaignAllDocumentsZipFileReadyMessageData,
  validateCampaignVersionReportFileReadyMessageData,
  validateCampaignVisitorsListChangesMessageData,
  validateContractVariationReportFileReadyMessageData,
  validatPlacementAllDocumentsZipFileReadyMessageData,
  validatPlacementOneDocumentsZipFileReadyMessageData,
} from "@specsheet-common/shared-types";
import { useDownloadPublicFile } from "../queryHooks/clientFile/mutations/useDownloadPublicFile";
import { WebsocketContextProps } from "src/contexts/WebsocketContext";
import { buildMessageId } from "@specsheet-common/shared-tools";

interface UseListenersProps {
  setIsWaitingForMessage: WebsocketContextProps["setIsWaitingForMessage"];
  setIsWaitingForDocumentDownloadMessage: WebsocketContextProps["setIsWaitingForDocumentDownloadMessage"];
  stopWaitingForMessage: WebsocketContextProps["stopWaitingForMessage"];
}

export const useListeners = ({
  setIsWaitingForMessage,
  setIsWaitingForDocumentDownloadMessage,
  stopWaitingForMessage,
}: UseListenersProps): Listeners => {
  const downloadFileMutation = useDownloadPublicFile({});

  return {
    [socketMessageKinds.campaignVersionReportFileReady]: async (
      data,
      callback
    ) => {
      const messageData = validateCampaignVersionReportFileReadyMessageData(
        JSON.parse(data)
      );

      await downloadFileMutation.mutateAsync(messageData.clientFileId);
      setIsWaitingForMessage(false);
      callback();
    },
    [socketMessageKinds.contractVariationReportFileReady]: async (data) => {
      const messageData = validateContractVariationReportFileReadyMessageData(
        JSON.parse(data)
      );

      await downloadFileMutation.mutateAsync(messageData.clientFileId);
      stopWaitingForMessage(
        buildMessageId({
          kind: socketMessageKinds.contractVariationReportFileReady,
          data: messageData,
        })
      );
    },
    [socketMessageKinds.userUpdated]: (callback) => {
      callback();
    },
    [socketMessageKinds.campaignAllDocumentsZipFileReady]: async (data) => {
      const messageData = validateCampaignAllDocumentsZipFileReadyMessageData(
        JSON.parse(data)
      );
      await downloadFileMutation.mutateAsync(messageData.clientFileId);
      setIsWaitingForDocumentDownloadMessage((prevState) => ({
        ...prevState,
        campaign: false,
      }));
    },
    [socketMessageKinds.placementAllDocumentsZipFileReady]: async (data) => {
      const messageData = validatPlacementAllDocumentsZipFileReadyMessageData(
        JSON.parse(data)
      );
      await downloadFileMutation.mutateAsync(messageData.clientFileId);
      setIsWaitingForDocumentDownloadMessage((prevState) => ({
        ...prevState,
        placement: false,
      }));
    },
    [socketMessageKinds.placementOneDocumentsZipFileReady]: async (data) => {
      const messageData = validatPlacementOneDocumentsZipFileReadyMessageData(
        JSON.parse(data)
      );
      await downloadFileMutation.mutateAsync(messageData.clientFileId);
      setIsWaitingForDocumentDownloadMessage((prevState) => ({
        ...prevState,
        placementOne: false,
      }));
    },
    [socketMessageKinds.campaignVisitorsUpdated]: (data, callback) => {
      const messageData = validateCampaignVisitorsListChangesMessageData(data);
      callback(messageData);
    },
    [socketMessageKinds.applicationVersion]: (data, callback) => {
      const messageData = validateApplicationVersionMessageData(
        JSON.parse(data)
      );
      callback(messageData.version);
    },
  };
};
